document.addEventListener('DOMContentLoaded', () => {

    const myCustomStyle = {
        stroke: true,
        color: '#fff',
        weight: 1,
        fill: true,
        fillColor: '#288EFB',
        fillOpacity: 1
    }

    const statusSelect = document.getElementById('statusFilter');
    const categorySelect = document.getElementById('categoryFilter');
    const countrySelect = document.getElementById('countryFilter');
    const resetButton = document.getElementById('reset-filters');

    function onEachFeature(feature, layer) {
        // layer.addEventListener('click', function (e) {
        //   console.log(e.target.feature.properties.admin);
        // });
    }

    const iconWhite = L.icon({
        iconUrl: '/wp-content/plugins/tbf-blocks/assets/images/leaflet/pin_white_hc.png',
        iconSize: [26, 32],
        iconAnchor: [13, 32]
    });

    const iconOrange = L.icon({
        iconUrl: '/wp-content/plugins/tbf-blocks/assets/images/leaflet/pin_orange_hc.png',
        iconSize: [26, 32],
        iconAnchor: [13, 32]
    });

    let windowWidth = 2.25;
    const mapElement = document.getElementById('map');

    if (window.innerWidth <= 600) {
        windowWidth = 1;
        mapElement.style.height = '400px';
    }

    var map = L.map('map', {
        attributionControl: false,
        zoomSnap: 0.25,
        scrollWheelZoom: false,
        dragging: ! L.Browser.mobile
    }).setView([40.423494,-3.682068], windowWidth);
    map._layersMaxZoom = 8;

    let markers = {};

    function resetMarkers() {
        
        Object.entries(markers).forEach((entry) => {
            const [country, countryData] = entry;

            // Remove existing markers
            map.removeLayer(countryData.cluster);
        });
        markers = {};
    }

    const overlay = document.getElementById('overlay');

    const projectView = document.getElementById('project-view');
    const countryView = document.getElementById('country-view');

    const overlayProjectProjects = document.getElementById('overlay-project-projects');

    const overlayCountryName = document.getElementById('overlay-country-name');
    const overlayCountryCount = document.getElementById('overlay-country-count');
    const overlayCountryProjects = document.getElementById('overlay-country-projects');

    const closeOverlayButton = document.getElementById('close-overlay');

    function showOverlay() {
        overlay.style.display = 'flex';
    }

    function hideOverlay() {

        resetPinColors();

        overlay.style.display = 'none';
    }

    function nameToSlug(name) {
        
        let slug = name.replace(/\s+/g, '-').toLowerCase();

        return slug;
    }

    closeOverlayButton.addEventListener('click', hideOverlay);

    function resetPinColors() {
        // Reset all markers to white
        markerSet.forEach((marker) => {
            marker.marker.setIcon(iconWhite);
        });
    }

    function renderState(location) {

        console.warn(location);

        if (location.state && location.country == 'United States') {
            return `<li>State: <span>${ location.state }</span></li>`;
        } else {
            return '';
        }
        
    }


    function  markerOnClick(project, marker) {
        
        resetPinColors();

        // Set current marker to orange
        marker.setIcon(iconOrange);

        let categories_markup = '';

        if (project._embedded && project._embedded['wp:term'][0].length != 0) {

            let cat_count  = 1;

            project._embedded['wp:term'][0].forEach((category) => {

                if (cat_count < project._embedded['wp:term'][0].length) {
                    categories_markup += category.name + ', ';
                } else {
                    categories_markup += category.name;
                }

                cat_count++;

            });
        }

        let markup =    `<li>Country: <span>${ project.acf.location.country ? project.acf.location.country : '' }</span></li>`
                        + renderState(project.acf.location) +
                        `<li>City: <span>${ project.acf.location.city ? project.acf.location.city : '' }</span></li>
                        <li>Type of Project: <span>${ categories_markup }</span></li>
                        <li>Status: <span className='caps'>${ project.acf.project_status ? project.acf.project_status.replace('-', ' ') : '' }</span></li>
                        <li>Company(s): <span>${ project.acf.companies ? project.acf.companies : '' }</span></li>
                        <li>Recycling Capacity / Year: <span>${ project.acf.recycling_capacity ? project.acf.recycling_capacity.toLocaleString() + ' tonnes' : '' }</span></li>
                        <li>More Information: 
                            <div>${ project.acf.more_information }</div>
                        </li>`

        overlayProjectProjects.innerHTML = markup;
            

         // Toggle on project view
         projectView.style.display = 'flex';
         countryView.style.display = 'none';

         showOverlay();
    }

    // fetch('/wp-content/plugins/tbf-blocks/assets/leaflet/custom.geo.json')
    fetch('/wp-content/plugins/tbf-blocks/assets/leaflet/custom.geo.json')
        .then(geojson => geojson.json())
        .then(function (geojson) {

            L.geoJson(geojson, {
                clickable: true,
                style: myCustomStyle,
                onEachFeature: onEachFeature
            }).addTo(map);

        })
        .catch(function() {
            // Error
        });


    function buildCountryOptions(projects) {

        let countries = []

        countrySelect.innerHTML = '';

        // Sort countries alphabetically
        const sorted = projects.sort((a, b) => {
            if (a.acf.location.country < b.acf.location.country) {
                return -1;
            }
            if (a.acf.location.country > b.acf.location.country) {
                return 1;
            }

            return 0;
        });

        let defaultOption = document.createElement('option');
        defaultOption.textContent = 'Select a country';
        defaultOption.value = '';
        defaultOption.selected = true;  
        defaultOption.disabled = true;  
        countrySelect.appendChild(defaultOption);

        Object.values(sorted).forEach(country => {

            if ( ! countries.includes(nameToSlug(country.acf.location.country))) {

                let option = document.createElement('option');

                option.textContent = country.acf.location.country;
                option.value = nameToSlug(country.acf.location.country);

                countrySelect.appendChild(option);

                countries.push(nameToSlug(country.acf.location.country));

            }

        });
    }

    let activeFilters = {
        country: null,
        status: null,
        category: null
    }

    let allProjects = [];

    function addToOrCreateMarkersCluster(project, marker) {

        if ( ! markers[nameToSlug(project.acf.location.country)] ) {
            markers[nameToSlug(project.acf.location.country)] = {
                cluster: L.markerClusterGroup({ 
                    spiderfyOnMaxZoom: true,
                    maxClusterRadius: 140,
                    spiderfyDistanceMultiplier: 1.5,
                    showCoverageOnHover: false, 
                }),
                country: project.acf.location.country,
                projects: [ project ]
            };
        } else {
            markers[nameToSlug(project.acf.location.country)].projects.push(project);
        }

        markers[nameToSlug(project.acf.location.country)].cluster.addLayer( marker );
    }

    let markerSet = [];

    // Function that adds a click event to each marker-links element
    function addMarkerLinksClickEvent() {

        const markerLinks = document.querySelectorAll('.marker-links');

        markerLinks.forEach((link) => {

            link.addEventListener('click', (e) => {

                e.preventDefault();

                const latlng = link.dataset.marker.split(',');

                const found = markerSet.find((marker) => marker.lat == latlng[0] && marker.lng == latlng[1]);

                if (found) {
                    map.setView(latlng, 6);
                    found.marker.fire('click');
                }                

            });

        });
    }
        

    function addAllClustersToMap(markers) {
        
        Object.entries(markers).forEach((entry) => {
                
            const [country, countryData] = entry;
            
            // Add click event for cluster group
            countryData.cluster.on('clusterclick', function (a) {

                // a.layer.zoomToBounds({padding: [0, 0]});

                resetPinColors();

                overlayCountryName.innerHTML = countryData.country;
                overlayCountryCount.innerHTML = countryData.projects.length;

                let projects_markup = '';

                countryData.projects.sort((a, b) => {
                    if (a.acf.companies < b.acf.companies) {
                        return -1;
                    }
                    if (a.acf.companies > b.acf.companies) {
                        return 1;
                    }
                    return 0;
                });

                countryData.projects.forEach((project) => {
                    // Add a link that acts as a click event for the matching marker
                    projects_markup += `<li><a href="#" class="marker-links" data-marker="${project.acf.location.lat},${project.acf.location.lng}">${project.title.rendered}</a></li>`;
                });  

                overlayCountryProjects.innerHTML = projects_markup;

                addMarkerLinksClickEvent();


                // Toggle on country view
                projectView.style.display = 'none';
                countryView.style.display = 'flex';

                showOverlay();
            });
            
            countryData.cluster.addTo(map);
        });
    }

    function setUpMarker(project) {

        let marker = L.marker([project.acf.location.lat, project.acf.location.lng], {icon: iconWhite});

        marker.on('click', () => {
            markerOnClick(project, marker);
        } );

        markerSet.push({
            lat: project.acf.location.lat,
            lng: project.acf.location.lng,
            marker: marker
        });

        if (project.acf.location.country) {
            
            addToOrCreateMarkersCluster(project, marker);

        }
    }

    function addMarkers() {
       
        // Handles initial addition of all projects
        if ( ! activeFilters.country && ! activeFilters.status && ! activeFilters.category ) {

            let test = [];

            allProjects.forEach((project) => {

                setUpMarker(project); 

            });

            addAllClustersToMap(markers);

            return;
        }


        const matchingProjects = allProjects.filter((project) => {

            if (activeFilters.status && project.acf.project_status !== activeFilters.status) {
                return false;
            }

            if (activeFilters.category && ! project.project_categories.includes( parseInt(activeFilters.category))) {
                return false;
            }

            if (activeFilters.country && nameToSlug(project.acf.location.country) !== activeFilters.country) {
                return false;
            }

            return true;

        });

        matchingProjects.forEach((project) => {
            setUpMarker(project);
            addAllClustersToMap(markers);
        });

    }

    // Updated this on 11/14/24 to loop through and collect projects now that there are more than 100
    let paged = 0;
    function fetchAllProjects() {

        paged++;

        fetch('/wp-json/wp/v2/projects?_embed=1&per_page=100&page=' + paged)
            .then(projects => projects.json())
            .then(function (projects) {

                allProjects.push(...projects);

                if (projects.length < 100) {
                    buildCountryOptions(allProjects)
                    addMarkers();
                } else {
                    fetchAllProjects();
                }

            })
            .catch(function() {
                // Error
            });
    }

    fetchAllProjects();
    
    function resetMap() {
        map.setView([40.423494,-3.682068], 2.25);
    }
    
    function updateFilters(target, filterType) {

        // Update activeFilters object
        activeFilters[filterType] = target.value;

        resetMarkers();

        addMarkers();
    }

    statusSelect.addEventListener('change', (e) => {
        updateFilters(e.target, 'status');
        resetMap();
    });

    categorySelect.addEventListener('change', (e) => {
        updateFilters(e.target, 'category');
        resetMap();
    });

    countrySelect.addEventListener('change', (e) => {
        updateFilters(e.target, 'country');
        resetMap();
    })

    resetButton.addEventListener('click', (e) => {

        // Reset activeFilters object
        activeFilters.country =  null;
        activeFilters.status =  null;
        activeFilters.category =  null;

        // Reset select elements
        statusSelect.selectedIndex = 0;
        categorySelect.selectedIndex = 0;
        countrySelect.selectedIndex = 0;
        
        resetMarkers();

        addMarkers();

        hideOverlay();

        resetMap();
        
    
    });

});